module.exports = __webpack_public_path__ + "static/media/logo-pdf.2bfa9bd0.png";